export default __webpack_public_path__ + "a4a00a4b1fc0f548d516cedcfb0d1235.svg";